<!-- Path: libs/components/inputs/src/lib/lib-input-select/input-select.component.html -->
<div
  class="ui-input-select"
  [class.ui-input-select--open]="isOpen()"
  [class.ui-input-select--invalid]="hasError"
  [class.ui-input-select--disabled]="disabled"
>
  <button
    type="button"
    class="ui-input-select__trigger"
    [id]="id"
    [disabled]="disabled"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-controls]="id + '-panel'"
    aria-haspopup="listbox"
    (click)="togglePanel()"
    (keydown)="onTriggerKeydown($event)"
    (blur)="onBlur()"
  >
    <span
      class="ui-input-select__value"
      [class.ui-input-select__value--placeholder]="!hasValue"
    >
      {{ displayValue }}
    </span>

    <span class="ui-input-select__actions">
      @if (hasValue && !disabled) {
        <span
          class="ui-input-select__clear"
          role="button"
          tabindex="0"
          aria-label="Limpar seleção"
          (click)="$event.stopPropagation(); clearSelection()"
          (keydown.enter)="$event.stopPropagation(); clearSelection()"
        >
          ×
        </span>
      }

      <span class="ui-input-select__chevron" aria-hidden="true"></span>
    </span>
  </button>

  @if (isOpen()) {
    <div
      class="ui-input-select__panel"
      [id]="id + '-panel'"
      role="listbox"
      (scroll)="onPanelScroll($event)"
    >
      @if (visibleOptions.length) {
        @for (option of visibleOptions; track option.value) {
          <button
            type="button"
            class="ui-input-select__option"
            [class.ui-input-select__option--selected]="selectedOption?.value === option.value"
            [class.ui-input-select__option--disabled]="option.disabled"
            [disabled]="option.disabled"
            (click)="selectOption(option)"
          >
            <span class="ui-input-select__option-label">
              {{ option.resolvedLabel }}
            </span>

            @if (option.description) {
              <span class="ui-input-select__option-description">
                {{ option.description }}
              </span>
            }
          </button>
        }

        @if (visibleOptions.length < resolvedOptions.length) {
          <div class="ui-input-select__more">
            Exibindo {{ visibleOptions.length }} de {{ resolvedOptions.length }}
          </div>
        }
      } @else {
        <div class="ui-input-select__empty">
          Nenhuma opção disponível
        </div>
      }
    </div>
  }
</div>